import React from 'react';
import { connect } from 'react-redux';
import { setSaleOrLease, setSearchText, setSortOrder } from '../store/actions';
import type { SaleOrLease, SortDirection, SortField, SortOrder } from '../types';
import { Form } from 'react-bootstrap-5';

type FiltersProps = {
  saleOrLease: SaleOrLease;
  searchText: string;
  sort: SortOrder;
  setSaleOrLease: (saleOrLease: SaleOrLease) => void;
  setSearchText: (searchText: string) => void;
  setSortOrder: (sort: Partial<SortOrder>) => void;
}

function Filters({ saleOrLease, searchText, sort, setSaleOrLease, setSearchText, setSortOrder } : FiltersProps) {
  return (
    <div className="d-flex gap-2 my-2">
      <Form.Group>
        <Form.Label>Search:</Form.Label>
        <Form.Control
          type="text"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          placeholder="Search listings..."
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Sale/Lease</Form.Label>
        <Form.Select
          value={saleOrLease}
          onChange={e => setSaleOrLease(e.target.value as SaleOrLease)}
        >
          <option value="all">All</option>
          <option value="sale">Sale</option>
          <option value="lease">Lease</option>
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Sort By:</Form.Label>
        <Form.Select
          value={sort.field}
          onChange={e => setSortOrder({ field: e.target.value as SortField })}
        >
          <option value="address">Address</option>
          <option value="city">City</option>
          <option value="state">State</option>
          <option value="zip">Zip/Postal Code</option>
        </Form.Select>
      </Form.Group>
      <Form.Group>
        <Form.Label>Direction:</Form.Label>
        <Form.Select
          value={sort.direction}
          onChange={e => setSortOrder({ direction: e.target.value as SortDirection })}
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </Form.Select>
      </Form.Group>
    </div>
  );
}
const mapStateToProps = ({ listings: { saleOrLease, sort, searchText }}) => ({ saleOrLease, sort, searchText });

export default connect(mapStateToProps, { setSaleOrLease, setSearchText, setSortOrder })(Filters);
